import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import {
  FreeBetMaxPayoutPopUp,
  MaxWinPopup,
  SlowConnectionWr,
  UnderMaintenanceWr,
  freeBetStore,
} from '@pascal/pascal-core';

import GameCenterSide from '../../containers/gameCenterSide';
import RoundResultPart from '../../components/roundResultPart';

export const MobileGameMain = observer(() => {
  const { endedFreeBets } = freeBetStore;
  const ref = useRef();

  // useEffect(() => {
  //   if (!ref.current) return;
  //   gameDrawer.setupRoot(ref.current);
  // }, [ref.current]);

  useEffect(() => {
    if (endedFreeBets.length) {
      freeBetStore.handleFreeBetEndedData();
    }
  }, [endedFreeBets.length]);

  return (
    <>
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <div className='new-fishing-wrapper'>
        <div ref={ref} />
        <MaxWinPopup />
        <FreeBetMaxPayoutPopUp />
        <GameCenterSide />
        <RoundResultPart />
      </div>
    </>
  );
});
